import { render, staticRenderFns } from "./HistoryHeader.vue?vue&type=template&id=5b45fe59&scoped=true&"
import script from "./HistoryHeader.vue?vue&type=script&lang=js&"
export * from "./HistoryHeader.vue?vue&type=script&lang=js&"
import style0 from "./HistoryHeader.vue?vue&type=style&index=0&id=5b45fe59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b45fe59",
  null
  
)

export default component.exports